export function toPreviewText(value = "", max = 20) {
  const plain = String(value || "")
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
  if (!plain) return "";
  return plain.length > max ? `${plain.slice(0, max)}...` : plain;
}

export function buildCreateField(values = {}, activeIsos = []) {
  return activeIsos.reduce((acc, iso) => {
    acc[iso] = String(values?.[iso] ?? "");
    return acc;
  }, {});
}

export function buildUpdateField(values = {}, ids = {}, activeIsos = []) {
  return activeIsos.reduce((acc, iso) => {
    const normalizedValue = String(values?.[iso] ?? "");
    acc[iso] = {
      id: normalizedValue ? ids?.[iso] || "" : "",
      value: normalizedValue,
    };
    return acc;
  }, {});
}

export function buildTourAudioPayload(multimedia = [], activeIsos = []) {
  const normalizedIsos = (Array.isArray(activeIsos) ? activeIsos : [])
    .map((iso) => String(iso || "").toLowerCase().trim())
    .filter(Boolean);
  const allowedIsos = new Set(normalizedIsos);
  const groupedAudios = new Map();
  (Array.isArray(multimedia) ? multimedia : [])
    .filter((item) => {
      const mediaType = String(item?.mediaType || "").toLowerCase();
      const mimeType = String(item?.mimeType || "").toLowerCase();
      const languageIso = String(item?.languageIso || "")
        .toLowerCase()
        .trim();
      return (
        (mediaType === "audio" || mimeType.startsWith("audio/")) &&
        item?.mediaRole === "promoAudio" &&
        languageIso &&
        allowedIsos.has(languageIso)
      );
    })
    .forEach((audio) => {
      const iso = String(audio?.languageIso || "").toLowerCase().trim();
      const groupId = String(
        audio?.audioGroupId || audio?.sourceId || audio?.id || "",
      ).trim();
      if (!groupId) return;
      const current = groupedAudios.get(groupId) || {
        id: groupId,
        multimediaId: "",
        multimediaIds: {},
        title: {},
        audioUrls: {},
      };
      current.multimediaId =
        current.multimediaId || audio?.sourceId || audio?.id || "";
      current.multimediaIds[iso] = audio?.sourceId || audio?.id || "";
      current.title[iso] = String(audio?.audioTitles?.[iso] || "");
      current.audioUrls[iso] = audio?.url || "";
      groupedAudios.set(groupId, current);
    });
  return Array.from(groupedAudios.values())
    .map((item) => {
      const multimediaIds = {};
      const title = {};
      const audioUrls = {};
      normalizedIsos.forEach((iso) => {
        multimediaIds[iso] = String(item?.multimediaIds?.[iso] || "");
        title[iso] = String(item?.title?.[iso] || "");
        audioUrls[iso] = String(item?.audioUrls?.[iso] || "");
      });
      return { ...item, multimediaIds, title, audioUrls };
    })
    .filter((item) => Object.keys(item?.audioUrls || {}).length > 0);
}

export function buildTourPromoVideoPayload(multimedia = [], activeIsos = []) {
  const payload = activeIsos.reduce((acc, iso) => {
    const promoVideo = (multimedia || []).find((item) => {
      const mediaType = String(item?.mediaType || "").toLowerCase();
      const mimeType = String(item?.mimeType || "").toLowerCase();
      return (
        (mediaType === "video" || mimeType.startsWith("video/")) &&
        item?.mediaRole === "promoVideo" &&
        item?.languageIso === iso
      );
    });
    if (!promoVideo?.id) return acc;
    acc[iso] = {
      multimediaId: promoVideo?.sourceId || promoVideo?.id || "",
      url: promoVideo?.url || "",
    };
    return acc;
  }, {});
  return Object.keys(payload).length ? payload : null;
}
